import Vue from 'vue'
import Component from 'vue-class-component'
@Component
export default class Api extends Vue {
	myMixinValue = 'Fetch my mixin';
}